import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { cloudfish } from "../../Assets";
import SendPinCode from "../../Components/ForgetPassword/SendPinCode";
import VerifyPinCode from "../../Components/ForgetPassword/VerifyPinCode";
import ResetPassword from "../../Components/ForgetPassword/ResetPassword";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [formState, setFormState] = useState(0);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: "",
    new_password: "",
    conform_password: "",
    reset_token: "",
  });

  const handleLogin = () => navigate(`/login`);

  const formsData = {
    formData,
    setFormData,
    setErrors,
    errors,
    setFormState,
    handleLogin,
  };

  return (
    <div className="login-card">
      <div className="login-header">
        <div className="logo-box mb-3">
          <img src={cloudfish} alt="App Logo" className="login-logo" />
        </div>
        <h1>Enterprise Partners Portal</h1>
        <h5>{`${
          formState == 1
            ? "Verify OTP"
            : formState == 2
            ? "Reset Password"
            : "Send OTP"
        }`}</h5>
      </div>

      {formState === 1 ? (
        <VerifyPinCode {...formsData} />
      ) : formState === 2 ? (
        <ResetPassword {...formsData} />
      ) : (
        <SendPinCode {...formsData} />
      )}
      <hr className="login-border-line" />
      <div className="bottom-content">
        <div className="content-left">
          <div>HIPPA Compliant</div>
        </div>
        <div className="content-right">
          <div>Enterprise goate Security</div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
